// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rule-config-page {\n  padding-top: 20px;\n  padding-left: 10px;\n  background-color: white;\n}\n.rule-config-page .input-from .el-form-item__content {\n    width: 100%;\n    height: 90%;\n}\n.rule-config-page .input-border {\n    height: 100%;\n}\n.rule-config-page .input-border .el-textarea__inner {\n      width: 100%;\n      height: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
